import React, { useState, useEffect } from "react";
import moonSVG from "../../assets/moon.svg";
import sunSVG from "../../assets/sun.svg";

export const themes = {
  dark: "",
  light: "light",
};

const ThemeContext = React.createContext({
  dark: themes.dark,
  light: themes.light,
  icon: "",
  changeTheme: () => {},
});

export const ThemeContextProvider = (props) => {
  let savedTheme = localStorage.getItem("collectorTheme");
  // call method to retrieve stored theme from local storage
  const [theme, setTheme] = useState(savedTheme ? savedTheme : themes.dark);
  const [icon, setIcon] = useState(
    savedTheme === themes.light ? moonSVG : sunSVG
  );

  useEffect(() => {
    theme === themes.light
      ? document.body.classList.add(themes.light)
      : document.body.classList.remove(themes.light);
    localStorage.setItem("collectorTheme", theme);
    setIcon(theme === themes.light ? moonSVG : sunSVG);
  }, [theme]);

  const toggleTheme = () => {
    setTheme(savedTheme === themes.light ? themes.dark : themes.light);
  };

  const currentTheme = () => {
    return theme;
  };

  const contextValue = {
    light: themes.light,
    dark: themes.dark,
    icon: icon,
    toggleTheme: toggleTheme,
    currentTheme: currentTheme,
  };

  return (
    <ThemeContext.Provider value={contextValue}>
      {props.children}
    </ThemeContext.Provider>
  );
};

export default ThemeContext;
